import React, { useCallback, useState } from 'react'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import api from '../../helpers/api'
import { Question } from '../../types/Question'
import { QuestionAnswer } from '../../types/QuestionAnswer'
import { CheckItem } from '../CheckItem'

export const ReplyQuestion = ({ question }: Props) => {

    const [openHint,setOpenHint] = useState<boolean>(false)

    const [alternativeCheck,setAlternativeCheck] = useState<QuestionAnswer[]>(question.answer ? question.answer : [])

    const handleSubmit = useCallback( async (value:string,alternative_id:string) => {
        let params = {
            id:alternative_id,
            points:value
        }
        await api.post(`/client/questions/${question.id}`, params).then( res => {
            setAlternativeCheck(res.data)
        }).catch(console.log)
    },[question])

    console.log(alternativeCheck)
    return (
        <form className='bg-white p-3 my-3 rouded border-l-4 border-t border-b border-r  border-green-400 rounded-lg shadow-md'>
            <div className='flex justify-between items-center border-b-2 border-gray-300 mb-1 py-2'>
                    <div className='text-justify'>{question.question}</div>
                    <div>
                    <div>{question.multiple ? <div>Múltipla escolha</div> : ""}</div>
                    </div>
            </div>
            {question.hint &&
            <div className='mb-3 grid grid-cols-12 w-full justify-between'>
                <div className='col-span-11'>
                {openHint &&
                <div className='border-l-2 rounded-md border-green-300  pl-1'>
                  <strong className='font-semibold'>Explicação:</strong>   {question.hint}
                </div>
                }
                </div>
                <div className='col-span-1 flex justify-end'>
                <AiOutlineQuestionCircle className='text-lg' onClick={()=>setOpenHint(prev=> prev? false : true)} />
                </div>

            </div>
            }
            {question.alternatives.map(item => (
                <div key={item.id} className={`border-l-2 my-1 mb-4 p-1
                        ${alternativeCheck.find( answer => answer.alternative_id === item.id ) ? "border-primary" : "border-gray-600"} rounded-lg`}>
                    <CheckItem
                        type={'radio'}
                        name={`questions[${question.id}][points]`}
                        defaultValue={item.points}
                        label={item.alternative}
                        defaultChecked={alternativeCheck.find( answer => answer.alternative_id === item.id ) ? true : false}
                        onClick={()=>handleSubmit(item.points,item.id)}
                    />
                    <input hidden name={`questions[${question.id}][question_id]`} defaultValue={question.id} />
                </div>
            ))}
        </form>
    )
}
interface Props {
    question: Question
}
